import axios from 'axios';

export default function get(
  partnershipId,
  contributorIds,
  daysAgo,
  cachedPerformanceDataUrl,
  fromCache,
) {
  const source = axios.CancelToken.source();
  let task;

  if (fromCache && cachedPerformanceDataUrl) {
    task = axios.get(cachedPerformanceDataUrl, {
      cancelToken: source.token,
    });
  } else {
    task = axios.get(`/api/v1/analytics/wires/published/partnership/${partnershipId}`, {
      params: {
        contributor_ids: contributorIds,
        days_ago: daysAgo,
      },
      cancelToken: source.token,
    });
  }

  return [task, source];
}
